'use strict';

var StrategyReadonlyAllocationAuthAvailActionsDirective = function StrategyReadonlyAllocationAuthAvailActionsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/strategy-readonly-allocation-auth-avail-actions.html'),
    controller: 'StrategyReadonlyAllocationAuthAvailActionsController',
    scope: {
      strategyActions: '='
    }
  };
};
StrategyReadonlyAllocationAuthAvailActionsDirective.$inject = [];
module.exports = StrategyReadonlyAllocationAuthAvailActionsDirective;